import { render, staticRenderFns } from "./BottledWater.vue?vue&type=template&id=66d42dfc"
import script from "./BottledWater.vue?vue&type=script&lang=js"
export * from "./BottledWater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports